<div data-test="RUksttui" (mdOutsideClick)="hideFilter()">
  <button
    *ngIf="!ngrxFormControl.value"
    data-test="bWzCJfo0"
    class="icon icon_sm"
    (click)="showFilter()"
  >
    <svg data-test="roN4KViM" class="icon__icon-filter" width="10px" height="10px">
      <use xlink:href="#icon-filter"></use>
    </svg>
  </button>
  <div
    data-test="FScXk5P_"
    class="dropdown dropdown_bottom-middle dropdown_arrow dropdown_search-tooltip"
    [ngClass]="{ 'show active': show }"
  >
    <div data-test="NADdiS7I" class="dropdown__wrap p-0">
      <md-datepicker
        #datepicker
        data-test="3VHlQ9F1"
        inputClasses="input_sm w-auto"
        [ngrxFormControlState]="ngrxFormControl"
        [ngrxValueConverter]="dateValueConverter"
        (dateChange)="hideFilter(); emitSelected()"
      ></md-datepicker>
    </div>
  </div>
  <span data-test="ixezIUEM" *ngIf="ngrxFormControl.value">
    <span data-test="B4-gbyDQ" class="cursor-pointer" (click)="showFilter()">
      ({{ ngrxFormControl.value | formatDate }})
    </span>
    <i
      data-test="6F4p38BS"
      class="material-icons md-12 cursor-pointer"
      (click)="onClearClick()"
    >
      close
    </i>
  </span>
</div>
